import * as React from "react";
import { SVGProps } from "react";
const SvgFileAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#file-alert_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6 5v2H5v23h15v-1h2v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2Zm14-5a1 1 0 0 1 .608.206l.1.087 6 6a1 1 0 0 1 .283.576L27 7v19a1 1 0 0 1-.883.993L26 27H9a1 1 0 0 1-.993-.883L8 26V1a1 1 0 0 1 .883-.993L9 0h11Zm-1 2h-9v23h15V8h-5a1 1 0 0 1-.993-.883L19 7V2Zm-2 17a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm0-10a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1Zm6.585-3L21 3.415V6h2.585Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="file-alert_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFileAlert;
